import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M21.75 20A2.75 2.75 0 0 1 19 22.75H5A2.75 2.75 0 0 1 2.25 20v-9.25h19.5zM16 1.25a.75.75 0 0 1 .75.75v1.25H19A2.75 2.75 0 0 1 21.75 6v3.25H2.25V6A2.75 2.75 0 0 1 5 3.25h2.25V2a.75.75 0 0 1 1.5 0v1.25h6.5V2a.75.75 0 0 1 .75-.75" />
  </>
);

const CalendarFilled = Icon('calendar-filled', svgContents);

export default CalendarFilled;
